
import * as storyblokRuntime$_41dIMmj6sqcU_qzVGvkxutVu59YHCPhQ0kPRHbJBY9U from '/codebuild/output/src3925525253/src/bitbucket.org/magusa/cavu-workspaces/node_modules/.pnpm/@nuxt+image@1.10.0_db0@0.3.2_ioredis@5.6.1_magicast@0.3.5/node_modules/@nuxt/image/dist/runtime/providers/storyblok'
import * as ipxRuntime$JC94bH5kFrgAvUKkp4yT_45oDni87hAnK5D_zUwhGx6Yw from '/codebuild/output/src3925525253/src/bitbucket.org/magusa/cavu-workspaces/node_modules/.pnpm/@nuxt+image@1.10.0_db0@0.3.2_ioredis@5.6.1_magicast@0.3.5/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['storyblok']: { provider: storyblokRuntime$_41dIMmj6sqcU_qzVGvkxutVu59YHCPhQ0kPRHbJBY9U, defaults: {"baseURL":"https://a.storyblok.com"} },
  ['ipx']: { provider: ipxRuntime$JC94bH5kFrgAvUKkp4yT_45oDni87hAnK5D_zUwhGx6Yw, defaults: {} }
}
        